import { trimScript } from './trimScript';
import { validateScript } from './validateScript';

export const processOneLinks = (oneLinkResult: string, rootDomain: string) => {
  if (typeof document === 'undefined' || !oneLinkResult || !rootDomain) return;
  const processedUrl = new URL(oneLinkResult);
  const onelinkAttributions = new URLSearchParams(processedUrl.search);
  const allOneLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(
    `a[href^="${rootDomain}"]`,
  );

  Array.from(allOneLinks).forEach(link => {
    const linkUrl = new URL(link.href);
    const linkParams = new URLSearchParams(linkUrl.search);

    // Append all existing query parameters from the original link
    onelinkAttributions.forEach((value, key) => {
      if (!linkParams.has(key)) {
        linkParams.set(key, value);
      }
    });
    // Reconstruct the full URL with updated parameters
    linkUrl.search = linkParams.toString();

    // eslint-disable-next-line no-param-reassign
    link.href = linkUrl.toString();
  });

  // Impression Logic - send impression after 1 second if result is returned
  // @see https://dev.appsflyer.com/hc/docs/dl_smart_script_v2#fire-an-impression
  setTimeout(() => {
    if (typeof window.AF_SMART_SCRIPT.fireImpressionsLink === 'function') {
      console.log('Firing AppsFlyer SmartScript impression');
      window.AF_SMART_SCRIPT.fireImpressionsLink();
    }
  }, 1000);
};

export const buildSmartScriptProcessing = (script: string, domain: string) => {
  const trimmedScript = trimScript(script);
  const validationErrors = validateScript(trimmedScript);

  if (validationErrors.length > 0) {
    // eslint-disable-next-line no-console
    console.error('Validation errors in AppsFlyer script:', validationErrors);
    return null;
  }

  const scriptString = `
    window.onload = () => {
      if (typeof window.AF_SMART_SCRIPT === 'undefined') {
        console.error('AppsFlyer SmartScript SDK is not loaded.');
      }
      const oneLinkURL = '${domain}';
      ${trimmedScript}
      (${processOneLinks.toString()})(result.clickURL, oneLinkURL);
    };
  `;

  return scriptString;
};
